import {
  Button,
  Modal,
  TextLink,
} from "@moneyforward/mfx_biz_react_components";
import { css } from "@emotion/react";

type Props = {
  loading: boolean;
  onClickCancel: () => void;
  onClickChange: () => void;
};

const URL_FQA_PAGE =
  "https://support.id.x.moneyforward.com/hc/ja/articles/9053621496473-Mikatano-ID%E3%81%AE%E6%A8%A9%E9%99%90%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6%E6%95%99%E3%81%88%E3%81%A6%E3%81%8F%E3%81%A0%E3%81%95%E3%81%84-" as const;

export const ChangeMemberConfirmModal: React.FC<Props> = ({
  loading,
  onClickCancel,
  onClickChange,
}) => {
  const body = () => (
    <div css={bodyCSS}>
      <div>
        一般権限では一部の機能が利用できません。
        <br />
        権限の種類については
        <TextLink href={URL_FQA_PAGE} target="_blank" rel="noopener noreferrer">
          よくある質問
        </TextLink>
        をご確認ください。
        <br />
        再度管理者へ権限を変更する場合は、メールアドレスの認証が必要です。
      </div>
      <div>一般権限へ変更しますか？</div>
    </div>
  );
  const footer = () => (
    <div css={footerCSS}>
      <Button onClick={onClickCancel} variant="secondary">
        キャンセル
      </Button>
      <Button onClick={onClickChange} disabled={loading}>
        変更
      </Button>
    </div>
  );

  return (
    <div css={ChangeMemberConfirmModalCSS}>
      <Modal
        title="一般へ変更"
        body={body()}
        zIndex={1000}
        footerButtons={footer()}
        onClose={onClickCancel}
      />
    </div>
  );
};

const ChangeMemberConfirmModalCSS = css({
  display: "flex",
});

const bodyCSS = css({
  display: "flex",
  "flex-direction": "column",
  gap: "1.6rem",
  "margin-top": "1.6rem",
});

const footerCSS = css({
  display: "flex",
  gap: "1.6rem",
});
